import { combineReducers } from 'redux';

import { uiReducer } from './ui';
import { appReducer } from './app';
import { authReducer } from './auth';
import { userProfileReducer } from './userProfile';
import { datasetsReducer } from './datasets';
import { artsReducer } from './arts';
import { statisticsReducer } from './statistics';

// NOTE:
// We handle app reset action in reducers separately instead of doing that in the root reducer.
// The reason is that redux-persist doesn't handle changes in the root reducer.
// As a result when we reset store there is still some state saved in storage by redux-persist.
// Purge method of redux-persist doesn't work for us, because it removes all the state from
// storage instead of resetting it which may cause some problems later
// By handling app reset action separately in reducers redux-persist handles changes
// and writes reseted state to disk
export const rootReducer = combineReducers({
  app: appReducer,
  ui: uiReducer,
  auth: authReducer,
  userProfile: userProfileReducer,
  datasets: datasetsReducer,
  arts: artsReducer,
  statistics: statisticsReducer,
});
